export default "__VITE_ASSET__DhZmxMsy__"